import { useEffect } from 'react';
import { useBrand } from './ServerBrandProvider';

export const DynamicAdminTitle = () => {
  const { brand, loading } = useBrand();

  useEffect(() => {
    if (!loading && brand) {
      document.title = 'DistillHQ';
    }
  }, [brand, loading]);

  return null; // This component doesn't render anything
};